<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">点呼代行回数履歴</strong>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <section class="card">
          <div class="card-header">
            <h2>現在の代行回数設定</h2>
          </div>
          <div class="card-body">
            <div v-if="loadingRollCallCountHistoryCurrent">
              <a-spin tip="Loading..." />
            </div>
            <div v-else>
              <div v-for="(plan, index) in rollCallCountHistoryCurrent" :key="index">
                <div v-if="Object.keys(plan.roll_call_count).length > 0" style="margin-bottom: 40px;">
                  <h3 style="margin-bottom: 10px;">{{ planName[plan.plan] }} プラン</h3>
                  <div v-for="(roll_call_count, index) in plan.roll_call_count" :key="index" style="margin-left: 25px; margin-bottom: 10px;">
                    <h5 style="margin-bottom: 5px; margin-top: 10px;">契約コール数 {{ index }}回: {{ roll_call_count.count }}人</h5>
                    <div v-if="agentRollCallAddAuto === 2">
                      <div v-for="(added, index) in roll_call_count.added" :key="index" style="margin-left: 50px;">
                        <p style="margin-bottom: 0;">・追加コール数 {{ index }}回: {{ added }}人</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="col-lg-12">
        <section class="card">
          <div class="card-header">
            <h2>点呼代行回数履歴</h2>
          </div>
          <div class="card-body">
            <a-config-provider :locale="locale">
              <a-form layout="inline" style="margin-bottom: 10px;">
                対象月：
                <a-month-picker
                  :value="currentMonth"
                  style="width: 30%;"
                  @change="targetMonthChange"
                />
              </a-form>
            </a-config-provider>
            <div v-if="loadingRollCallCountHistory" class="text-center">
              <a-spin tip="Loading..." />
            </div>
            <div v-if="!loadingRollCallCountHistory">
              <a-table
                :columns="columnsRollCallCountHistory"
                :data-source="rollCallCountHistory"
                rowKey="id"
                :rowClassName="(r, i) => i % 2 === 0 ? $style.stripe1 :  $style.stripe0"
              >
                <span slot="user_name" slot-scope="id, record">
                  <router-link :to="{ name: 'userShow', params: { id: record.user_id }}">{{ record.user_name }}</router-link>
                </span>
                <span slot="plan" slot-scope="plan">
                  {{ planName[plan] }}
                </span>
                <span slot="roll_call_count" slot-scope="roll_call_count">{{ roll_call_count }}</span>
                <span slot="roll_call_count_used" slot-scope="roll_call_count_used">{{ roll_call_count_used }}</span>
                <span slot="roll_call_count_added" slot-scope="id, record">
                  <span v-if="agentRollCallAddAuto === 1">{{ record.roll_call_count_used - record.roll_call_count > 0 ? record.roll_call_count_used - record.roll_call_count : 0 }}</span>
                  <span v-if="agentRollCallAddAuto === 2">{{ record.roll_call_count_max - record.roll_call_count > 0 ? record.roll_call_count_max - record.roll_call_count : 0 }}</span>
                </span>
              </a-table>
              <div class="text-right">
                <a-button type="primary" autoInsertSpaceInButton="false" :class="$style.filledBtn" @click="outputCSV">CSV出力</a-button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import jaJa from 'ant-design-vue/es/locale/ja_JP'
import 'moment/locale/ja'

export default {
  data() {
    return {
      locale: jaJa,
      planName: ['全日／24時間', '時間外', '平日／24時間'],
      currentMonth: moment().format('YYYY-MM'),
      agentRollCallAddAuto: 0,
      loadingRollCallCountHistory: true,
      loadingRollCallCountHistoryCurrent: true,
      rollCallCountHistory: [],
      rollCallCountHistoryCurrent: [],
      columnsRollCallCountHistory: [
        { title: '名前', dataIndex: 'user_name', scopedSlots: { customRender: 'user_name' } },
        { title: 'プラン', dataIndex: 'plan', scopedSlots: { customRender: 'plan' } },
        { title: '契約コール数', dataIndex: 'roll_call_count', scopedSlots: { customRender: 'roll_call_count' } },
        { title: '使用コール数', dataIndex: 'roll_call_count_used', scopedSlots: { customRender: 'roll_call_count_used' } },
        { title: '追加コール数', dataIndex: 'roll_call_count_added', scopedSlots: { customRender: 'roll_call_count_added' } },
      ],
    }
  },

  created() {
    const companyRequest = Vue.prototype.$api.send('get', 'company')
    companyRequest.then(response => {
      this.agentRollCallAddAuto = response.agent_roll_call_add_auto
    })
      .catch(error => {
        this.$notification['error']({
          message: error.status + ': 会社情報の取得に失敗しました。',
        })
      })

    const resultRollCallCountHistoryCurrent = Vue.prototype.$api.send('get', 'roll_call_count_history/current')
    resultRollCallCountHistoryCurrent.then(response => {
      this.rollCallCountHistoryCurrent = [
        {
          plan: 0,
          roll_call_count: {},
        },
        {
          plan: 1,
          roll_call_count: {},
        },
        {
          plan: 2,
          roll_call_count: {},
        },
      ]
      response.forEach(u => {
        if (typeof this.rollCallCountHistoryCurrent[parseInt(u.roll_call_limited)].roll_call_count[u.roll_call_count] === 'undefined') {
          this.rollCallCountHistoryCurrent[parseInt(u.roll_call_limited)].roll_call_count[u.roll_call_count] = {
            count: 1,
            added: {
              [u.roll_call_count_max - u.roll_call_count]: 1,
            },
          }
        } else {
          this.rollCallCountHistoryCurrent[parseInt(u.roll_call_limited)].roll_call_count[u.roll_call_count].count += 1
          if (typeof this.rollCallCountHistoryCurrent[parseInt(u.roll_call_limited)].roll_call_count[u.roll_call_count].added[u.roll_call_count_max - u.roll_call_count] === 'undefined') {
            this.rollCallCountHistoryCurrent[parseInt(u.roll_call_limited)].roll_call_count[u.roll_call_count].added[u.roll_call_count_max - u.roll_call_count] = 1
          } else {
            this.rollCallCountHistoryCurrent[parseInt(u.roll_call_limited)].roll_call_count[u.roll_call_count].added[u.roll_call_count_max - u.roll_call_count] += 1
          }
        }
      })
      this.loadingRollCallCountHistoryCurrent = false
    })
      .catch(error => {
        this.$notification['error']({
          message: error.status + ': 現在の設定の取得に失敗しました。',
        })
      })
    this.refleshRollCallCountHistory()
  },
  beforeMount() {
  },
  methods: {
    refleshRollCallCountHistory() {
      this.loadingRollCallCountHistory = true
      const resultRollCallCountHistory = Vue.prototype.$api.send('get', 'roll_call_count_history/' + moment(this.currentMonth).format('YYYY-MM-01'))
      resultRollCallCountHistory.then(response => {
        this.rollCallCountHistory = response
        this.loadingRollCallCountHistory = false
      })
        .catch(error => {
          this.$notification['error']({
            message: error.status + ': 点呼代行回数履歴の取得に失敗しました。',
          })
          this.loadingRollCallCountHistory = false
        })
    },
    targetMonthChange(val) {
      this.currentMonth = val
      this.refleshRollCallCountHistory()
    },
    outputCSV() {
      const month = moment(this.currentMonth).format('YYYY年MM月')
      const planName = ['全日／24時間', '時間外', '平日／24時間']
      let csv = '\ufeff'
      csv += 'user_id,名前,月,プラン,契約数,使用数,追加数'
      csv += '\n'
      this.rollCallCountHistory.forEach(u => {
        let rollCallCountAdded = 0
        if (this.agentRollCallAddAuto === 1) {
          rollCallCountAdded = u['roll_call_count_used'] - u['roll_call_count'] > 0 ? u['roll_call_count_used'] - u['roll_call_count'] : 0
        } else if (this.agentRollCallAddAuto === 2) {
          rollCallCountAdded = u['roll_call_count_max'] - u['roll_call_count'] > 0 ? u['roll_call_count_max'] - u['roll_call_count'] : 0
        }
        csv += u['user_id'] + ',' + u['user_name'] + ',' + month + ',' + planName[u['plan']] + ',' + u['roll_call_count'] + ',' + u['roll_call_count_used'] + ',' + rollCallCountAdded
        csv += '\n'
      })
      var blob = new Blob([csv], { type: 'text/plain' })
      var link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'roll_call_count_history_' + month + '.csv'
      link.click()
    },
  },
}
</script>
<style lang="scss" module>
@import '@/assets/styles/mixins.scss';
</style>
<style>
.list-name {
  font-size: 1.5rem;
}
</style>
